export default "__VITE_ASSET__Cm53bRIX__"